import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core'

@Directive({
  selector: '[mixedTranslation]',
})
export class MixedTranslationDirective implements OnInit {
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @Input() value: string | undefined

  ngOnInit(): void {
    if (this.value === undefined) return
    const componentTags = this.extractComponentTags(this.value)
    const splittedValue = this.splitString(this.value)
    splittedValue.forEach((item) => {
      if (item === '<br />' || item === '<br/>' || item === '<br>') {
        const br = this.renderer.createElement('br')
        this.renderer.appendChild(this.elementRef.nativeElement, br)
        return
      }
      if (/<[^>]+>/.test(item)) {
        const tag = componentTags.find((tag) => item.includes(tag))
        if (!tag) return
        const elem = this.elementRef.nativeElement.querySelector(`[${tag}]`)
        if (elem) {
          this.renderer.appendChild(this.elementRef.nativeElement, elem)
        } else {
          // 일치하는게 없으면 그냥 text로 추가
          const textNode = this.renderer.createText(item.replace(/ /g, '\u00A0'))
          this.renderer.appendChild(this.elementRef.nativeElement, textNode)
        }
      } else {
        const textNode = this.renderer.createText(item.replace(/ /g, '\u00A0'))
        this.renderer.appendChild(this.elementRef.nativeElement, textNode)
      }
    })
  }

  private splitString(input): string[] {
    // 정규식: 태그와 그 외 텍스트를 모두 캡처
    const regex = /(<[^>]+\/?>.*?<\/[^>]+>|<[^>]+\/?>|[^<]+)/g

    // 문자열을 정규식에 맞게 분리
    return input.match(regex)
  }

  private extractComponentTags(value: string): string[] {
    // 정규식: <로 시작하고 />로 끝나는 태그의 내용 추출
    const regex = /<([^>]+)\/>/g
    let matches: RegExpExecArray | null
    const results: string[] = []
    // 모든 매칭 결과를 순회하며 태그 내용만 추출
    while ((matches = regex.exec(value)) !== null) {
      results.push(matches[1].trim()) // 태그 내용 추출 및 트림
    }
    return results
  }
}
